import axiosPublic from "../api/axiosConfig";
import { toast } from "react-toastify";

const ACCESS_TOKEN_KEY = "accessToken";
const TOKEN_EXPIRATION_KEY = "tokenExpiration";

export const refreshAccessToken = async () => {
  try {
    // const response = await axios.post("http://localhost:8080/token/refresh");
    // const response = await axios.post(
    //   "http://192.168.0.201:8080/token/refresh"
    // );

    const response = await axiosPublic.post("/spotify/token/refresh");
    const newAccessToken = response.data;
    const expiresIn = 3600;
    const expirationTime = Date.now() + expiresIn * 1000;

    localStorage.setItem(ACCESS_TOKEN_KEY, newAccessToken);
    localStorage.setItem(TOKEN_EXPIRATION_KEY, expirationTime);

    return newAccessToken;
  } catch (err) {
    toast.error("Failed to refresh token. Please try again later.");
    throw err;
  }
};

export const getAccessToken = async () => {
  const storedToken = localStorage.getItem(ACCESS_TOKEN_KEY);
  const tokenExpiration = localStorage.getItem(TOKEN_EXPIRATION_KEY);

  if (storedToken && tokenExpiration && Date.now() < tokenExpiration) {
    return storedToken;
  }

  return await refreshAccessToken();
};
